import { mapGetters } from 'vuex';
import utils from '../libs/utils';

export default {
  data() {
    return {
      goodsStoreStatusList: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      maintainTypeList: new Map([
        [1, '一般养护'],
        [2, '重点养护'],
      ]),
      paymentTypeList: new Map([
        [1, '普通'],
        [2, '寄售'],
      ]),
      modalLoading: false,
      modalVisiable: false,
      modalQuery: {
      },
      modalParams: {},
      modalPage: {
        page: 1,
        size: 10,
        count: 0,
      },
      tempSelection: [],
      modalTableData: [],
      modalColumns: [
        {
          title: '选择',
          key: 'id',
          type: 'selection',
          width: 60,
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '通用名',
          key: 'approvedDrugNames',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '批次',
          key: 'goodsBatchSeq',
          minWidth: 136,
          tooltip: true,
        },
        {
          title: '批准文号',
          key: 'approvalNumber',
          minWidth: 176,
          tooltip: true,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '生产企业',
          key: 'manufacturer',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品类型',
          key: 'goodsTypeName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '助记码',
          key: 'mnemonicCode',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'dosageForm',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '是否DTP',
          key: 'isDtpStr',
          minWidth: 116,
        },
        {
          title: '上市许可持有人',
          minWidth: 120,
          tooltip: true,
          key: 'mah',
        },
        {
          title: '产地',
          key: 'countryOfOrigin',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '来源',
          key: 'purchaseTypeName',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => {
            let purchaseTypeName = '';
            this.getGoodsOrigin.forEach((item) => {
              if (item.value === row.purchaseType) {
                purchaseTypeName = item.name;
              }
            });
            return h('span', purchaseTypeName);
          },
        },
        {
          title: '商品状态',
          key: 'goodsStoreStatus',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnit',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '仓库',
          key: 'warehouseName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '货位',
          key: 'locationCode',
          minWidth: 146,
          tooltip: true,
        },
        {
          title: '数量',
          key: 'goodsStockNum',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '报损冻结数量',
          key: 'breakageFrozenNum',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '销售冻结数量',
          key: 'saleFrozenNum',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '库存冻结数量',
          key: 'manualFrozenNum',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '供应商',
          key: 'supplierName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '生产日期',
          key: 'goodsProductionDate',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '有效期',
          key: 'goodsExpiryDate',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '安全库存',
          key: 'inventoryWarning',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '养护标准',
          key: 'maintainType',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '入库时间',
          key: 'createTime',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '在库天数',
          key: 'inStockDays',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品进价',
          key: 'priceBeforeTax',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '含税金额',
          key: 'taxInclusiveTotalAmount',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '不含税金额',
          key: 'taxExclusiveTotalAmount',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '税金',
          key: 'taxes',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '采购税率',
          key: 'taxRateStr',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '零售价格',
          key: 'retailPrice',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '成本类型',
          key: 'payment',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '近效期天数',
          key: 'nearlyEffectiveDays',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品标签',
          key: 'goodsLabel',
          minWidth: 116,
          tooltip: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
      'getNormalGoodsTypes',
    ]),
    selectedIds() {
      const result = [];
      this.formModel.tableData.forEach((item) => {
        result.push(item.id);
      });
      return result;
    },
    tempSelectionIds() {
      const result = [];
      this.tempSelection.forEach((item) => {
        result.push(item.id);
      });
      return result;
    },
  },
  methods: {
    exchangeInventoryGoods(item) {
      const result = item.inventoryInfo;
      result.mah = item.goodsInfoVo && item.goodsInfoVo.mah; // 药品上市持有人
      result.inputTaxRate = result.originInputTaxRate || 0; // 要修改成的进项税率
      result.originInputTaxRateStr = `${result.originInputTaxRate}%`; // 原进项税率
      result.taxRateStr = `${result.taxRate}%`; // 采购税率

      result.goodsStoreStatus = this.goodsStoreStatusList.get(result.goodsStoreStatus); // 商品状态
      result.maintainType = this.maintainTypeList.get(result.maintainType); // 养护标准
      result.payment = this.paymentTypeList.get(result.payment); // 成本类型

      result.goodsProductionDate = utils.exchangeTime(result.goodsProductionDate); // 生产日期
      result.goodsExpiryDate = utils.exchangeTime(result.goodsExpiryDate); // 有效期
      result.createTime = utils.exchangeTime(result.createTime); // 入库时间

      result._checked = this.selectedIds.includes(result.id) || this.tempSelectionIds.includes(result.id);
      result._disabled = this.selectedIds.includes(result.id);
      return result;
    },
    clearModalQuery() {
      this.modalQuery = {};
    },
    hideModal() {
      this.modalVisiable = false;
    },
    handleAdd() {
      this.modalVisiable = true;
      this.clearModalQuery();
      this.handleModalSearch();
    },
    handleModalSearch() {
      this.tempSelection = [];
      this.modalPage.page = 1;
      this.modalPage.size = 10;
      this.modalParams = utils.deepClone(this.modalQuery);
      this.getModalData();
    },
    pushModalData() {
      if (this.tempSelection.length === 0 && this.formModel.tableData.length === 0) {
        this.$Message.error('请选择记录');
        return;
      }

      if (this.tempSelection.length > 10) {
        this.$store.commit('setLoading', true);
        utils.timeChunk(this.tempSelection, (item) => {
          this.formModel.tableData.push(item);
        }, 10, () => {
          this.$store.commit('setLoading', false);
        })();
      } else {
        this.tempSelection.forEach((item) => {
          this.formModel.tableData.push(item);
        });
      }

      this.tempSelection = [];
      this.hideModal();
    },
    handleModalPage(val) {
      this.modalPage.page = val;
      this.getModalData();
    },
    handleModalSize(val) {
      this.modalPage.size = val;
      this.getModalData();
    },
    handleTempSelect(selection, row) {
      if (!this.tempSelectionIds.includes(row.id)) {
        this.tempSelection.push(row);
      }
    },
    handleTempCancel(selection, row) {
      this.tempSelection.forEach((item, index) => {
        if (item.id === row.id) {
          this.tempSelection.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.tempSelectionIds.includes(item.id) && !this.selectedIds.includes(item.id)) {
          this.tempSelection.push(item);
        }
      });
    },
    handleSelectAllCancel() {
      this.modalTableData.forEach((good) => {
        for (let i = 0, len = this.tempSelection.length; i < len; i++) {
          if (this.tempSelection[i].id === good.id) {
            this.tempSelection.splice(i, 1);
            break;
          }
        }
      });
    },
  },
};
